<template>
  <div>
    <div class="home-item-boxes--connected">
      <div
        v-for="cardDesign in cardDesigns"
        :key="cardDesign.id"
        class="item-box--connected"
        @click="onClickDesign(cardDesign)"
      >
        <div class="item-card-icon--connected">
          <ImgLazy
            :image-url="cardDesign.imageBoxUrl"
            alt-text="カードデザイン"
            aspect-ratio="1 / 1"
          />
        </div>
      </div>
    </div>
    <ImageModal
      v-if="showableImageModal"
      :image-url="imageUrl"
      :primary-button-text="'選択する'"
      :cancel-button-text="'閉じる'"
      :primary-button-disabled="modalPrimaryButtonDisabled"
      @clicked-modal-cover="closeModal"
      @clicked-primary="onClickedPrimary"
      @clicked-cancel="closeModal"
    />
    <TextImageModalWithSecondary
      v-show="showableTextImageModalWithSecondary"
      :image-url="imageUrl"
      image-aspect-ratio="1 / 1"
      :title-text="''"
      :caption-text="'作成できるカードは1つまでです\n内容を破棄して新規作成しますか？'"
      :primary-button-text="'新規作成する'"
      :secondary-button-text="'カードを確認する'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="onClickedPrimary"
      @clicked-secondary="onClickedSecondary"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import ImageModal from '../../../../molecules/modals/image-modal.vue'
import TextImageModalWithSecondary from '../../../../molecules/modals/with_secondary/text-image-modal-with-secondary.vue'
import ImgLazy from '../../../../atoms/images/ImgLazy.vue'
import axios from 'axios'

export default {
  components: {
    ImageModal,
    TextImageModalWithSecondary,
    ImgLazy
  },
  props: {
    cardDesigns: {
      type: Array,
      require: true,
      default: () => {}
    },
    isGiftCardEditing: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  data() {
    return {
      selectedDesign: null,
      modalPrimaryButtonDisabled: false
    }
  },
  computed: {
    imageUrl() {
      if (!this.selectedDesign || !this.selectedDesign.imageUrl) {
        return 'https://dummyimage.com/120x120/ccc/999.png&text=Not+Found'
      }
      return this.selectedDesign.imageUrl
    },
    showableImageModal() {
      return !this.isGiftCardEditing && this.selectedDesign !== null
    },
    showableTextImageModalWithSecondary() {
      return this.isGiftCardEditing && this.selectedDesign !== null
    }
  },
  methods: {
    onClickDesign(design) {
      this.selectedDesign = design
      dataLayer.push({
        event: 'click_top__card_design_modal',
        card_design_id: design.id
      })
    },
    closeModal() {
      this.selectedDesign = null
    },
    async onClickedPrimary() {
      this.modalPrimaryButtonDisabled = true
      dataLayer.push({
        event: 'click_card_design_modal__gift_card_edit',
        card_design_id: this.selectedDesign.id
      })

      try {
        await axios.patch('/api/v1/pickup/gift_card_sessions', {
          gift_card_session: {
            card_design_id: this.selectedDesign.id
          }
        })
        window.location.href = '/gift_card/edit'
      } catch (error) {
        // TODO: Rails 側でエラーが発生した際にフロント側でどのような処理をするかを検討し、ここに実装する
        if (
          !error.response ||
          !error.response.status ||
          !error.response.statusText
        ) {
          console.log(`Error :${error}`)
          return
        }
        const { status, statusText } = error.response
        console.log(`Error! HTTP Status: ${status} ${statusText}`)
        const errorMessage = error.response.data.message
        if (errorMessage) {
          console.log(`Error message: ${errorMessage}`)
        }
      }
      this.modalPrimaryButtonDisabled = false
    },
    onClickedSecondary() {
      location.href = '/gift_card/edit'
      this.closeModal()
    }
  }
}
</script>
